module.exports = __webpack_public_path__ + "img/empty.59de2200.png";